<!--
  TinoActivityTimeline.vue — Recent system events in a vertical timeline.
-->
<script setup>
import { useI18n } from 'vue-i18n'

const { t } = useI18n()

const events = [
  {
    id: 1,
    icon: 'mdi-file-document-outline',
    iconColor: '#6366f1',
    iconBg: '#eef2ff',
    time: '09:41 AM',
    actor: 'Tino',
    action: 'created quote',
    subject: 'Propuesta Web Básica',
    extra: 'Carlos López',
    chips: ['Quote #2241'],
  },
  {
    id: 2,
    icon: 'mdi-calendar-clock',
    iconColor: '#f59e0b',
    iconBg: '#fffbeb',
    time: '10:15 AM',
    actor: 'Tino',
    action: 'scheduled follow-up for',
    subject: 'Propuesta Web Básica',
    extra: 'Tomorrow 9 AM',
    chips: [],
  },
  {
    id: 3,
    icon: 'mdi-sync',
    iconColor: '#0ea5e9',
    iconBg: '#f0f9ff',
    time: '11:00 AM',
    actor: 'System',
    action: 'synced catalog — 3 products updated',
    subject: '',
    extra: '',
    chips: ['Products', 'Catalog'],
  },
  {
    id: 4,
    icon: 'mdi-credit-card-check-outline',
    iconColor: '#22c55e',
    iconBg: '#f0fdf4',
    time: '01:28 PM',
    actor: 'Payment gateway',
    action: 'confirmed payment',
    subject: '',
    extra: '$1,200.00 MXN',
    chips: ['Invoice #0088'],
  },
  {
    id: 5,
    icon: 'mdi-alert-circle-outline',
    iconColor: '#ef4444',
    iconBg: '#fef2f2',
    time: '02:05 PM',
    actor: 'Invoice sync',
    action: 'failed — connection timeout',
    subject: '',
    extra: 'Retry scheduled',
    chips: [],
  },
]
</script>

<template>
  <VCard class="tino-timeline-card" flat>
    <!-- Header -->
    <div class="tino-timeline-header">
      <div class="d-flex align-center gap-2">
        <VIcon icon="mdi-timeline-outline" size="18" color="primary" />
        <span class="text-sm font-weight-semibold">{{ t('dashboard.tino.timeline.title') }}</span>
      </div>
      <span class="text-xs text-medium-emphasis">Today</span>
    </div>

    <VDivider />

    <!-- Events -->
    <div class="tino-timeline-body">
      <div
        v-for="(ev, idx) in events"
        :key="ev.id"
        class="tino-event"
      >
        <!-- Icon + connector -->
        <div class="tino-event-left">
          <div
            class="tino-event-icon"
            :style="{ background: ev.iconBg }"
          >
            <VIcon :icon="ev.icon" size="16" :color="ev.iconColor" />
          </div>
          <div v-if="idx < events.length - 1" class="tino-connector" />
        </div>

        <!-- Content -->
        <div class="tino-event-body">
          <p class="text-xs text-high-emphasis mb-1">
            <strong>{{ ev.actor }}</strong>
            {{ ev.action }}
            <span v-if="ev.subject" class="font-italic">"{{ ev.subject }}"</span>
            <span v-if="ev.extra" class="text-medium-emphasis"> · {{ ev.extra }}</span>
          </p>
          <p class="text-[10px] text-disabled mb-1">{{ ev.time }}</p>
          <div v-if="ev.chips.length" class="d-flex flex-wrap gap-1">
            <VChip
              v-for="chip in ev.chips"
              :key="chip"
              size="x-small"
              color="primary"
              variant="tonal"
            >
              {{ chip }}
            </VChip>
          </div>
        </div>
      </div>
    </div>
  </VCard>
</template>

<style scoped lang="scss">
.tino-timeline-card {
  border: 1px solid rgba(var(--v-border-color), 0.1);
  border-radius: 16px !important;
  background: rgb(var(--v-theme-surface));
  overflow: hidden;
  block-size: 100%;
}

.tino-timeline-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 20px;
}

.tino-timeline-body {
  padding: 16px 20px;
}

.tino-event {
  display: flex;
  gap: 12px;
}

.tino-event-left {
  display: flex;
  flex-direction: column;
  align-items: center;
  flex-shrink: 0;
}

.tino-event-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  inline-size: 30px;
  block-size: 30px;
  border-radius: 50%;
  flex-shrink: 0;
}

.tino-connector {
  inline-size: 2px;
  flex-grow: 1;
  min-block-size: 16px;
  background: rgba(var(--v-border-color), 0.18);
  margin-block: 4px;
}

.tino-event-body {
  padding-block-end: 16px;
  flex: 1;
}
</style>
